import React, { useEffect, useState } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ECharts, { EChartsReactProps } from 'echarts-for-react';
const moment=require('moment-jalaali');
let dates=[];
let newArr=[]
for(let i=1;i<31;i++){
  let date=moment().subtract(i,'days').format('jYY/jM/jD')
  const arr=dates.unshift(date);
  
 
}
const d=<CalendarMonthIcon/>;


for(let o=0;o<1;o++){
  const hours=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]
  for(let j=0;j<hours.length;j++){
    newArr.push(`${dates[o]} \n ${hours[j]}:00 `)

  }
}



const StChart = ({stats,flag}) => {
  const colors = ['#5470C6', '#91CC75', '#EE6666','orange','purple'];
const [walk,setWalk]=useState([])
const [temp,setTemp]=useState([])
const [ch,setCh]=useState([]);
const [re,setRe]=useState([]);
const [sl,setSl]=useState([])
const [ti,setTi]=useState([])
const [timeformat,setTimeFormat]=useState([])
useEffect(()=>{
 if(stats){
  const che=stats&&stats?.map(item=>{
    const {chewing}=item;
    
    return chewing
  })
  setCh(che)
  const rum=stats&&stats?.map(item=>{
    const {rumination}=item;
    
    return rumination
  })
  setRe(rum)
  const sle= stats&&stats?.map(item=>{
    const {sleeping,standing}=item;
   
    return sleeping+standing
  })
  setSl(sle)
  const tmp= stats&&stats?.map(item=>{
    const {temperature}=item;
   
    return temperature.toFixed(1)
  })
  setTemp(tmp)
  const wlk= stats&&stats?.map(item=>{
    const {humidity}=item;
   
    return humidity.toFixed(1)
  })
  setWalk(wlk)
  const tim= stats&&stats?.map(item=>{
    const {intervalTime}=item;
   const day=moment(intervalTime).format(`jDD`)
   const time=moment(intervalTime).format(`HH`)
    return `${day}\n${time}`
  })
  setTi(tim)
  const timf= stats&&stats?.map(item=>{
    const {intervalTime}=item;
   const day=moment(intervalTime).format(`jMM/jDD`)
   const time=moment(intervalTime).format(`HH:00`)
    return `${day}\n${time} `
  })
  setTimeFormat(timf)
 }
},[stats])



  useEffect(()=>{
    setOptions({
      
      
      color: colors,
      // tooltip: {
      //   trigger: 'axis',
      //   valueFormatter: (timeformat) => '$' + value.toFixed(2)
        
      // },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
        
      },
      grid: {
        
      },
     
      legend: {

        data: ['    میزان نشخوار : ', '    میزان جویدن : ', '    میزان استراحت : ','    میزان  رطوبت : ','    میزان دما : ']
      },
      xAxis: [
        {
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          
          // prettier-ignore
          data: timeformat
        },
      
      ],
      dataZoom: [
        {
          type: 'slider',
          show: true,
          
          start: flag==0?0:85,
          end: 100
        },
        {
          start: 80,
          type: "inside"
        },
      ],
        
      yAxis: [
        
        {
          type: 'value',
          name: 'دقیقه',
          position: 'left',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: colors[2]
            }
          },
          axisLabel: {
            formatter: '{value} '
          }
        },
        {
          type: 'value',
          name: 'دما و رطوبت',
          position: 'right',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: colors[0]
            }
          },
          axisLabel: {
            formatter: '{value} ...'
          }
        }
      ],
     
      series: [
        {
          name: '    میزان استراحت : ',
          type: 'line',
          yAxisIndex: 0,

          data: sl
        },
        {
          name: '    میزان جویدن : ',
          type: 'line',
          yAxisIndex: 0,
          
          data: ch
        },
        {
          name: '    میزان نشخوار : ',
          type: 'line',
          yAxisIndex: 0,

          data: re
        }
        ,
        {
          name: '    میزان  رطوبت : ',
          type: 'line',
          yAxisIndex: 1,

          data: walk
        }
        ,
        {
          name: '    میزان دما : ',
          type: 'line',
          yAxisIndex: 1,

          data: temp
        }
      ],
      
    })
  },[ch,re,sl,temp,walk])


  const [options, setOptions] = useState({
    dataZoom: [
      {
        type: 'inside',
        throttle: 50
      }
    ],
    color: colors,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      }
    },
    grid: {
      
    },
   
    legend: {
      align:'right',
      data: ['میزان نشخوار :', 'میزان جویدن :', 'میزان استراحت :','    میزان  رطوبت : ','میزان دما :']
    },
    xAxis: [
      {
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        // prettier-ignore
        data: newArr
      },
    
    ],
    dataZoom: [
      {
        type: 'slider',
        show: true,
        
        start: 85,
        end: 100
      }],
    yAxis: [
      
      {
        type: 'value',
        name: 'دقیقه',
        position: 'left',
        alignTicks: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: colors[2]
          }
        },
        axisLabel: {
          formatter: '{value} دقیقه'
        }
      },
      {
        type: 'value',
        name: '...',
        position: 'right',
        alignTicks: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: colors[0]
          }
        },
        axisLabel: {
          formatter: '{value} ...'
        }
      }
    ],
    series: [
      {
        name: 'میزان استراحت :',
        type: 'line',
        yAxisIndex: 0,

        data: sl
      },
      {
        name: 'میزان جویدن :',
        type: 'line',
        yAxisIndex: 0,
        
        data: ch
      },
      {
        name: 'میزان نشخوار :',
        type: 'line',
        yAxisIndex: 0,
        data: re
      },
      {
        name: '    میزان  رطوبت : ',
        type: 'line',
        yAxisIndex: 1,
        data: walk
      },
      {
        name: 'میزان دما :',
        type: 'line',
        yAxisIndex: 1,
        data: temp
      }
    ]
	});	

	return (
    <ECharts
      
			option={options}
      opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
    />
  );
}
export default StChart